export const INSTANCE_MODES = {
  PROOFREADING: "proofreading",
  SYNCHRONIZATION: "synchronization"
}
